const baseURL = `${process.env.REACT_APP_BASE_URL}/api/`

const headers = {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
}

// API to get domain details
const ActiveNewsApi = async (
    token: string, // access token
    platform:string,
    package_id:number,
    countryId:number
): Promise<any> => {

    // alldetail=true will fetch all details about the domain
    const url = `${baseURL}active-news`;

     const data = new FormData();

    data.append("platform", platform);
    data.append("current_package_id", package_id.toString());
    data.append("country_id", countryId.toString());

    try {
        // fetch API 
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                ...headers,
                "Authorization": "Bearer " + token
            },
            body:data
        });
        return await response.json();
    } catch (error) {
        return Promise.reject;
    }
}

export { ActiveNewsApi }